import { createFeatureCache } from '@vend/utilities'
import { merge } from 'lodash'
import { VdFeatureManager } from '@vend/vend.js'
import angular from 'angular'
import { env } from '../../../lib/env'
import { WR_FEATURES } from '../constants'

const FEATURES_CACHE_KEY = 'vend-features'

const { ENVS } = env

const features = WR_FEATURES[ENVS.PRODUCTION]

if (env.isTest() || env.isDevelopment()) {
  merge(features, WR_FEATURES[ENVS.TEST])

  if (env.isDevelopment()) {
    merge(features, WR_FEATURES[ENVS.DEVELOPMENT])
  }
}

let filteredFeatures = Object.fromEntries(
  Object.entries(features).filter(([_, val]) => typeof val === 'boolean')
)

const featureCache = createFeatureCache(FEATURES_CACHE_KEY, filteredFeatures)

let whenInitialised: Promise<Record<string, boolean>> | null = null

export const initFeatureCache = () => {
  if (!whenInitialised) {
    whenInitialised = featureCache.refresh(filteredFeatures).catch(() => {
      return featureCache.getAll()
    })
  }
  return whenInitialised
}

export const getFeatureFromCache = (key: string) => featureCache.get(key)

export class VdFeatureManagerWrapper implements VdFeatureManager {
  public init() {
    return initFeatureCache()
  }

  public get(key: string) {
    return featureCache.get(key)
  }

  public refresh(features: string[] | Record<string, boolean>) {
    if (!Array.isArray(features)) {
      filteredFeatures = { ...filteredFeatures, ...features }
    }
    return featureCache.updateFeatures(features)
  }
}

angular
  .module('webregister')
  .service('vdFeatureManager', VdFeatureManagerWrapper)
